import { render, staticRenderFns } from "./ValidationErrors.vue?vue&type=template&id=f84fb37e&scoped=true&"
import script from "./ValidationErrors.vue?vue&type=script&lang=js&"
export * from "./ValidationErrors.vue?vue&type=script&lang=js&"
import style0 from "./ValidationErrors.vue?vue&type=style&index=0&id=f84fb37e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84fb37e",
  null
  
)

export default component.exports